<template>
  <footer id="FooterSite">
    <div id="suporteContainer">
      <div id="IconeCentralContainer">
        <img src="../assets/img/svg/Helpdesk.svg" />
        <h1>CENTRAL DE RELACIONAMENTO</h1>
      </div>

      <div id="numeroFooterContainer">
        <h1>
          Capitais e regiões metropolitanas
          <span class="numeroFooter">4000 2901</span> ou
          <span class="numeroFooter">0800 777 1022</span> demais localidades
        </h1>
      </div>

      <div id="emailFooterContainer">
        <h1>
          E-mail:
          <span class="numeroFooter"
            ><a href="mailto:relacionamento@movemais.com"
              >relacionamento@movemais.com</a
            ></span
          >
        </h1>
      </div>
    </div>

    <div id="mainFooterContainer">
      <section>
        <div class="topicoFooterContainer">
          <h1>Dúvidas?</h1>
          <ul class="ulFooter">
            <li>
              <router-link :to="{ name: 'FAQ' }" class="scrollup">
                FAQ (Perguntas Frequentes)
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'guide' }" class="scrollup">
                Guia de Instalação do TAG
              </router-link>
            </li>
            <li>
              <a
                href="/api/v2/archeion/downloadFileArcheion/tabela-de-tarifas-movemais"
                target="_blank"
              >
                Tarifas Move Mais
              </a>
            </li>
          </ul>
        </div>
        <div class="topicoFooterContainer">
          <h1>Políticas</h1>
          <ul class="ulFooter">
            <li>
              <a
                href="/api/v2/archeion/downloadFileArcheion/termos-e-condicoes-gerais-movemais"
                target="_blank"
                title="Termos e Condições"
              >
                Termos e Condições
              </a>
            </li>
            <li>
              <a
                href="/api/v2/archeion/downloadFileArcheion/aviso-de-privacidade-movemais"
                target="_blank"
              >
                Aviso de Privacidade
              </a>
            </li>

            <li>
              <a
                href="/api/v2/archeion/downloadFileArcheion/politica-de-cookies-movemais"
                target="_blank"
              >
                Política de Cookies
              </a>
            </li>

            <li>
              <a
                href="/api/v2/archeion/downloadFileArcheion/politica-de-reembolso-movemais"
                target="_blank"
              >
                Política de Reembolso
              </a>
            </li>
            <li>
              <a
                href="/api/v2/archeion/downloadFileArcheion/politica-da-qualidade-movemais"
                target="_blank"
              >
                Política da Qualidade
              </a>
            </li>
          </ul>
        </div>
        <div class="topicoFooterContainer">
          <h1>Compliance</h1>
          <ul class="ulFooter">
            <li>
              <a
                href="/api/v2/archeion/downloadFileArcheion/codigo-de-conduta-movemais"
                target="_blank"
              >
                Código de Conduta
              </a>
            </li>
            <li>
              <a
                href="https://www.contatoseguro.com.br/movemais"
                target="_blank"
              >
                Canal de Ética
              </a>
            </li>
            <li>
              <a
                href="/api/v2/archeion/downloadFileArcheion/requisitos-pre-aprovacao-provedores-externos-movemais"
                target="_blank"
              >
                Requisitos Fornecedores
              </a>
            </li>
          </ul>
        </div>
        <div class="topicoFooterContainer">
          <h1>Minha Conta</h1>
          <ul class="ulFooter">
            <li>
              <router-link :to="{ name: 'plans' }"> Planos </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'requests' }" tag="a">
                Pedidos
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'tag-activate' }" tag="a">
                Ativar TAG
              </router-link>
            </li>
          </ul>
        </div>
        <div class="topicoFooterContainer">
          <h1>Formas de Pagamento</h1>
          <div id="bandeirasContainer">
            <img src="../assets/img/svg/CardCartaoMastercard.svg" />
            <img src="../assets/img/svg/CardCartaoVisa.svg" />
            <img src="../assets/img/svg/CardCartaoElo.svg" />
            <img src="../assets/img/svg/CardPix.svg" />
          </div>
        </div>
      </section>

      <div class="container-certificados">
        <div
          class="wrapper-certificado"
          v-if="
            (selos[0] && selos[0].svg) ||
            (selos[1] && selos[1].svg) ||
            (selos[2] && selos[2].svg)
          "
        >
          <p id="title">Certificações ISO</p>
          <div class="certificados">
            <div v-if="selos[0] && selos[0].svg">
              <div v-html="selos[0].svg"></div>
            </div>

            <div v-if="selos[1] && selos[1].svg">
              <div v-html="selos[1].svg"></div>
            </div>

            <div v-if="selos[2] && selos[2].svg">
              <div v-html="selos[2].svg"></div>
            </div>
          </div>
        </div>

        <div class="wrapper-certificado" v-if="selos[3] && selos[3].svg">
          <p id="title">Selo MESC</p>
          <div
            class="certificados"
            style="display: flex; justify-content: center; align-items: center"
          >
            <div v-html="selos[3].svg"></div>
          </div>
        </div>

        <div class="wrapper-certificado" v-if="selos[4] && selos[4].svg">
          <p id="title">Reclame Aqui</p>
          <div class="certificados">
            <div v-html="selos[4].svg"></div>
          </div>
        </div>

        <div class="wrapper">
          <div class="iconesFooter">
            <p id="title">Consumidor</p>
            <div id="consumidorContainer">
              <a href="https://consumidor.gov.br" target="_blank">
                <img
                  src="../assets/img/svg/consumidorgov.svg"
                  id="consumidor"
                />
              </a>
            </div>
          </div>

          <div class="iconesFooter">
            <p id="title">Certificado</p>
            <div id="certificadoContainer">
              <img
                src="../assets/img/svg/sectigo-siteseal@3x.png"
                id="certificado"
              />
            </div>
          </div>
        </div>
      </div>
      <div id="iconesContainer">
        <div class="iconesFooter">
          <h1>Baixe nosso App</h1>
          <div>
            <a
              href="https://apps.apple.com/br/app/move-mais-ped%C3%A1gio-free-flow/id6747896915"
              target="_blank"
              id="appStoreContainer"
            >
              <img src="../assets/img/svg/AppStore.svg" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.movemais.morfeu"
              target="_blank"
            >
              <img src="../assets/img/svg/GooglePlay.svg" />
            </a>
          </div>
        </div>

        <div id="redesContainer">
          <h1>Acompanhe-nos</h1>
          <div id="redesSociaisContainer">
            <a href="https://www.facebook.com/MoveMais/" target="_blank">
              <img src="../assets/img/svg/facebook.svg" class="iconesRedes" />
            </a>
            <a href="https://www.instagram.com/movemais/" target="_blank">
              <img src="../assets/img/svg/Instagram.svg" class="iconesRedes" />
            </a>
            <a
              href="https://www.linkedin.com/company/move-mais/"
              target="_blank"
            >
              <img src="../assets/img/svg/linkedin.svg" class="iconesRedes" />
            </a>
            <a href="https://www.youtube.com/user/movemais" target="_blank">
              <img src="../assets/img/svg/youtube.svg" class="iconesRedes" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div id="footerCNPJ">
      <div>
        <h1>
          Move Mais Meios de Pagamento Ltda - CNPJ: 15.266.912/0001-87 -
          Inscrição Estadual: 181.239.134.110
        </h1>
        <h1>
          Endereço: Avenida Rodrigo Fernando Grillo, 207, Edifício Victoria
          Business, 20º andar - Araraquara, SP, Brasil - 14801-534
        </h1>
      </div>
    </div>
  </footer>
</template>
<style scoped lang="scss" src="./app-footer.css"></style>
<script>
import SealService from "../services/seals";

export default {
  data() {
    return {
      selos: [],
    };
  },
  async mounted() {
    this.selos = await SealService.getSelos();
  },
  computed: {
    payments() {
      if (!this.$store.getters.getAllPayments) return {};

      return this.$store.getters.getAllPayments;
    },
    showElo() {
      let p = this.$store.getters.getAllPayments;
      if (p) {
        return p["Elo"];
      }
      return false;
    },
    ios() {
      return window.document.ios;
    },
  },
};
</script>
<!--  -->



// WEBPACK FOOTER //
// app-footer.vue?38fa63e2